import { render, staticRenderFns } from "./IconsSettings.vue?vue&type=template&id=2deafb94&scoped=true&"
import script from "./IconsSettings.vue?vue&type=script&lang=js&"
export * from "./IconsSettings.vue?vue&type=script&lang=js&"
import style0 from "./IconsSettings.vue?vue&type=style&index=0&id=2deafb94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deafb94",
  null
  
)

export default component.exports